import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import { useFormState } from 'utils/hooks';
import { optionField, stringField } from 'common/utils/form/fieldTypes';
import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';

import * as nationalityActions from 'store/nationalities/actions';
import { FormBody } from 'common/components/drawer';
import Select from 'common/components/form/inputs/Select';

import selectDataFromState from 'utils/selectDataFromState';

import Input from 'common/components/form/inputs/Input';

const config = {
  name: stringField({ required: true }),
  country: optionField({ required: true })
};

const Form = ({ drawer, active, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateNationality, createNationality] = useActions([
    nationalityActions.updateNationality,
    nationalityActions.createNationality
  ]);

  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { fields, changeField, selectField } = useFormState(formState);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active && isOpen) {
      const initialValues = selectDataFromState(active, config);
      loadValues({ ...initialValues });
    } else if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { country, ...rest } = values;

    const params = {
      ...rest,
      table: 'nationalities',
      country_id: country ? country.id : null,
      id: active ? active.id : undefined
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updateNationality(params);
      } else {
        await createNationality(params);
        resetForm();
        refetchData();
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Nationality'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />

          <Select
            defaultOptions={() => getInitialAsyncValues('countries')}
            loadOptions={search => getAsyncOptions(search, 'countries')}
            getOptionValue={option => option.id}
            getOptionLabel={option => option.name}
            label="Country"
            isAsync
            onChange={e => selectField(e)}
            placeholder=""
            {...fields.country}
          />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default Form;
